module.exports = __webpack_public_path__ + "img/SBBTableauDeBord.c5f1db06.jpg";